import { render, staticRenderFns } from "./removeOrderDetail.vue?vue&type=template&id=5ed101a2"
import script from "./removeOrderDetail.vue?vue&type=script&lang=js"
export * from "./removeOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./removeOrderDetail.vue?vue&type=style&index=0&id=5ed101a2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports